import React, { useMemo } from 'react';
import classnames from 'classnames';
import { Text } from 'components/commons';
import styles from './field.module.scss';

const Field = ({
  width,
  children,
  className,
  label,
  filterLabel,
  message,
  customLabel,
  customMessage,
  noLabel = false,
  errorClassName,
  labelSuffix,
}) => {
  const labelDisplay = useMemo(() => {
    if (label && !noLabel) {
      return (
        <Text label className="break-all">
          {label}
        </Text>
      );
    } else if (filterLabel) {
      return (
        <Text color="text-black-light" strong>
          {filterLabel}
        </Text>
      );
    } else {
      return customLabel;
    }
  }, [label, filterLabel, customLabel, noLabel]);

  return (
    <div className={classnames(`${width ? `${width}` : `w-full`}`, className, styles.field)}>
      <div className="mb-xs flex justify-between">
        {labelDisplay} {labelSuffix}
      </div>
      <div>{children}</div>
      {customMessage || message ? (
        <div className={errorClassName || 'pn-error mt-xs'}>
          {customMessage || <Text error>{message}</Text>}
        </div>
      ) : null}
    </div>
  );
};

export default Field;
